import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SignOutMessageService {
  public showSignOutMessage = new BehaviorSubject<boolean>(false);
  public show() { this.showSignOutMessage.next(true) }
  public hide() { this.showSignOutMessage.next(false) }
}